import { getOperatingDate } from '@liquitics/transaction';
import { Subscription } from 'rxjs';
import { AppConfig } from './../../app.config';
import { DashboardEventService } from './../../dashboard/dashboard-event.service';
import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import * as moment from 'moment';

@Component({
    selector: 'app-replay-controller',
    templateUrl: './replay-controller.component.html',
    styleUrls: ['./replay-controller.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class ReplayControllerComponent implements OnInit, OnDestroy {
    readonly DOUBLE_MINUTES = 30;
    readonly SINGLE_MINUTES = 5;
    hour: string;
    minutes: string;
    asOfDateTimeLocal: string;
    asOfDateTimeHome: string;
    lowerBoundReached = false;
    upperBoundReached = false;
    minDatetime: moment.Moment;
    maxDatetime: moment.Moment;
    time: string;

    subscription: Subscription;

    constructor(private appConfig: AppConfig, private dashboardEventService: DashboardEventService) { }

    ngOnInit() {
        this.updateTime(this.appConfig.asOfDatetimeUTC);
        this.subscription = this.dashboardEventService.timeShiftSubject.subscribe({
            next: (m: moment.Moment) => {
                this.updateTime(m.clone().local());
            }
        });
        const tenantInfo = this.appConfig.getTenantInfo();
        this.maxDatetime = this.appConfig.getTodayStartUTC().clone().utc()
            .startOf('day').add(tenantInfo.utcEndOfDayHour, 'hours').subtract(1, 'minute');
        this.minDatetime = this.maxDatetime.clone().subtract(1, 'day').add(1, 'minute');
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    onTimeChange(event) {
        this.moveToNewTimeFromTimeString();
    }

    private updateTime(m: moment.Moment) {
        if (m) {
            this.hour = m.format('HH');
            this.minutes = m.format('mm');
            this.time = m.format('HH:mm');
            this.asOfDateTimeLocal = m.format('ddd MMM DD HH:mm');
            this.asOfDateTimeHome = m.utcOffset(this.appConfig.getTenantInfo().utcOffset).format('ddd MMM DD HH:mm');
        }
    }

    onDoubleBack() {
        const newTime = this.appConfig.asOfDatetimeUTC.clone().subtract(this.DOUBLE_MINUTES, 'minutes');
        this.moveToNewTime(newTime);
    }
    onSingleBack() {
        const newTime = this.appConfig.asOfDatetimeUTC.clone().subtract(this.SINGLE_MINUTES, 'minutes');
        this.moveToNewTime(newTime);
    }
    onSingleForward() {
        const newTime = this.appConfig.asOfDatetimeUTC.clone().add(this.SINGLE_MINUTES, 'minutes');
        this.moveToNewTime(newTime);
    }

    onDoubleForward() {
        const newTime = this.appConfig.asOfDatetimeUTC.clone().add(this.DOUBLE_MINUTES, 'minutes');
        this.moveToNewTime(newTime);
    }

    onToStart() {
        this.moveToNewTime(this.minDatetime);
    }

    onToEnd() {
        this.moveToNewTime(this.maxDatetime);
    }

    private moveToNewTime(newTime: moment.Moment) {
        const tenantInfo = this.appConfig.getTenantInfo();
        const proposedOperatingDateStr = getOperatingDate(newTime, tenantInfo.utcOffset, tenantInfo.utcEndOfDayHour);
        const currentOperatingDateStr = this.appConfig.getTodayString();
        this.lowerBoundReached = false;
        this.upperBoundReached = false;
        const now = moment();
        if (newTime > now) {
            newTime = now;
            this.upperBoundReached = true;
        } else {
            if (proposedOperatingDateStr < currentOperatingDateStr) {
                this.lowerBoundReached = true;
                newTime = newTime.utc().startOf('day').add(tenantInfo.utcEndOfDayHour, 'hours');
            } else if (proposedOperatingDateStr > currentOperatingDateStr) {
                this.upperBoundReached = true;
                newTime = newTime.utc().startOf('day').add(tenantInfo.utcEndOfDayHour, 'hours').subtract(1, 'minute');
            }
        }
        this.dashboardEventService.timeShiftSubject.next(newTime);
    }

    private moveToNewTimeFromTimeString() {
        const tenantInfo = this.appConfig.getTenantInfo();
        const currentOperatingDateStr = this.appConfig.getTodayString();
        let proposedNewDatetime = moment(moment(new Date()).format('YYYY-MM-DD') + ' ' + this.time);
        const proposedOperatingDateStr = getOperatingDate(proposedNewDatetime, tenantInfo.utcOffset, tenantInfo.utcEndOfDayHour);
        if (proposedOperatingDateStr < currentOperatingDateStr) {
            proposedNewDatetime = proposedNewDatetime.add(1, 'day');
        } else if (proposedOperatingDateStr > currentOperatingDateStr) {
            proposedNewDatetime = proposedNewDatetime.subtract(1, 'day');
        }
        this.dashboardEventService.timeShiftSubject.next(proposedNewDatetime);
    }
}
